import { getMDXComponent } from 'mdx-bundler/client';
import { useMemo } from 'react';
import { useLoaderData, type V2_MetaFunction } from '~/remix';
import { loader } from './_route.server';

export { loader };

export let meta: V2_MetaFunction = ({ data }) => [
  { title: `Sunset Messages - ${data?.title ?? 'Not Found'}` },
];

export default function () {
  const { code, title } = useLoaderData<typeof loader>();
  const Component = useMemo(() => getMDXComponent(code), [code]);

  return (
    <div className="bg-background-dark">
      {title && (
        <div className="sticky top-0 z-20 w-full bg-accent-dark/70 py-2 text-white">
          <h1 className="text-center text-2xl font-bold">{title}</h1>
        </div>
      )}
      <div className="mt-0">
        <div className="prose mx-auto bg-white px-8 pb-8 pt-0 sm:px-16 sm:pb-16 sm:pt-8">
          <Component
            components={{ PackageInfo: PackageInfo, Message: Message }}
          />
        </div>
      </div>
    </div>
  );
}

function PackageInfo() {
  const { packageName, messageCount } = useLoaderData<typeof loader>();

  return (
    <div>
      <h2>{packageName} Package</h2>
      <h3>This package includes {messageCount} unique messages</h3>
    </div>
  );
}

type MessageProps = {
  number: number;
  children: React.ReactNode;
};
function Message({ number, children }: MessageProps) {
  const { messageCount } = useLoaderData<typeof loader>();

  if (number > messageCount) {
    return null;
  }

  return (
    <p>
      Message #{number}: {children}
    </p>
  );
}
